// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 912) return "awsutilityVendor.0edcf381e22b22e3fd3d.js";
	if (chunkId === 123) return "muiVendor.776d22126ff8c0e5707b.js";
	// return url for filenames based on template
	return "chunk." + chunkId + ".js";
};